import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add } from "../../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../../components/DropdownApi";
import { UserSession } from "../../../models/UserSession";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { addEmployee, updateEmployee } from "../../../service/employeeService";
import { NprLookup } from "../../../service/api-service";
import S3ImagePreview from "../../../components/S3ImagePreview";
import { Avatar } from "primereact/avatar";
import { placeholder } from "../../../assets/placeholder";
import MultiDropdownApi from "../../../components/MultiDropdownApi";
import { siteEmployeeAdd, siteEmployeeUpdate } from "../../../service/siteService";
import { Grid } from "@mui/material";
import { useToast } from "../../../context/ToastContext";

export default function SiteEmployeeAdd(modalProps: any) {
  const record = modalProps.record;
  const toast = useToast();

  async function EmployeeAdd() {
    let createObject: any = {
      employee,
      appointment,
    };

    if (record?.id) {
      siteEmployeeUpdate(createObject, record.id).then((r: any) => {
        toast("success", "Employee Updated Successfully");
        modalProps.setReload?.(!modalProps.reload);
        modalProps.setVisible?.(false);
        if (modalProps.callback) modalProps.callback();
      });
      return;
    }
    siteEmployeeAdd(createObject).then((r: any) => {
      toast("success", "Employee Added Successfully");
      modalProps.setReload?.(!modalProps.reload);
      modalProps.setVisible?.(false);
      if (modalProps.callback) modalProps.callback();
    });
  }

  const [employee, setEmployee] = React.useState(record?.id || "");
  const [appointment, setAppointment] = React.useState(record?.appointment || "");

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DropdownApi
            disabled={record?.id}
            apiPath="employee"
            optionLabel="full_name"
            optionValue="id"
            label="Employee"
            selectedData={employee}
            setSelectedData={setEmployee}
          />
        </Grid>
        <Grid item xs={12}>
          <MultiDropdownApi
            apiPath="appointments"
            queryParams={{ employeeId: employee }}
            optionLabel="name"
            optionValue="id"
            label="Appointment"
            selectedData={appointment}
            setSelectedData={setAppointment}
          />
        </Grid>
      </Grid>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => EmployeeAdd()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
